// V1
import anablast from "./v1/src/anablast/anablast.config.vue";
import binocular_reading from "./v1/src/binocular_reading/binocular_reading.config.vue";
import comprehension from "./v1/src/comprehension/comprehension.config.vue";
import directional_response from "./v1/src/directional_response/directional_response.config.vue";
import flat_jump_vergence from "./v1/src/flat_jump_vergence/flat_jump_vergence.config.vue";
import flat_vergence from "./v1/src/flat_vergence/flat_vergence.config.vue";
import line_maze from "./v1/src/line_maze/line_maze.config.vue";
import motion_detection from "./v1/src/motion_detection/motion_detection.config.vue";
import movingwindow from "./v1/src/movingwindow/movingwindow.config.vue";
import perceptual_speed from "./v1/src/perceptual_speed/perceptual_speed.config.vue";
import peripheral from "./v1/src/peripheral/peripheral.config.vue";
import peripheral_chart from "./v1/src/peripheral_chart/peripheral_chart.config.vue";
import pong from "./v1/src/pong/pong.config.vue";
import phoria from "./v1/src/phoria/phoria.config.vue";
import randot from "./v1/src/randot/randot.config.vue";
import randot_jump from "./v1/src/randot_jump/randot_jump.config.vue";
import randot_vertical from "./v1/src/randot_vertical/randot_vertical.config.vue";
import randotin from "./v1/src/randotin/randotin.config.vue";
import randotin_jump from "./v1/src/randotin_jump/randotin_jump.config.vue";
import react from "./v1/src/react/react.config.vue";
import recognition from "./v1/src/recognition/recognition.config.vue";
import rotator from "./v1/src/rotator/rotator.config.vue";
import saccades from "./v1/src/saccades/saccades.config.vue";
import stereoacuity from "./v1/src/stereoacuity/stereoacuity.config.vue";
import tachistoscope from "./v1/src/tachistoscope/tachistoscope.config.vue";
import vectograph from "./v1/src/vectograph/vectograph.config.vue";
import visual_auditory from "./v1/src/visual_auditory/visual_auditory.config.vue";
import visual_memory from "./v1/src/visual_memory/visual_memory.config.vue";
import wordreading from "./v1/src/wordreading/wordreading.config.vue";
import jumble_scan from "./v1/src/jumble_scan/jumble_scan.config.vue";
import associated_phoria from "./v1/src/associated_phoria/associated_phoria.config.vue";
import calibration_check_v1 from "./v1/src/calibration_check_v1/calibration_check_v1.config.vue";

// V2
import bubble_pop from "./v2/src/bubble_pop/bubble_pop.config.vue";
import example_click_the_target from "./v2/src/example_click_the_target/example_click_the_target.config.vue";
import example_speech_to_text from "./v2/src/example_speech_to_text/example_speech_to_text.config.vue";
import dictation from "./v2/src/dictation/dictation.config.vue";
import okn_drum from "./v2/src/okn_drum/okn_drum.config.vue";
import calibration_check from "./v2/src/calibration_check/calibration_check.config.vue";
import memory_match from "./v2/src/memory_match/memory_match.config.vue";
import vergence from "./v2/src/vergence/vergence.config.vue";
import vergence_vertical from "./v2/src/vergence_vertical/vergence_vertical.config.vue";
import vergence_jump_base from "./v2/src/vergence_jump_base/vergence_jump_base.config.vue";
import vergence_jump_vertical from "./v2/src/vergence_jump_vertical/vergence_jump_vertical.config.vue";
import vergence_jump_inout from "./v2/src/vergence_jump_inout/vergence_jump_inout.config.vue";
import worth_four_dot from "./v2/src/worth_four_dot/worth_four_dot.config.vue";
import central_suppression_check from "./v2/src/central_suppression_check/central_suppression_check.config.vue";
import breakout from "./v2/src/breakout/breakout.config.vue";
import saccadic_rapid_naming from "./v2/src/saccadic_rapid_naming/saccadic_rapid_naming.config.vue";

export default {
  anablast,
  breakout,
  associated_phoria,
  binocular_reading,
  calibration_check_v1,
  bubble_pop,
  comprehension,
  directional_response,
  flat_jump_vergence,
  flat_vergence,
  line_maze,
  motion_detection,
  movingwindow,
  movingwindow_v2: movingwindow, // use movingwindow
  perceptual_speed,
  peripheral,
  peripheral_chart,
  pong,
  phoria,
  randot,
  randot_jump,
  randot_vertical,
  randot_vertical_jump: randot_vertical, // use randot_vertical
  randotin,
  randotin_jump: randotin_jump,
  randotout: randotin, // use randotin
  randotout_jump: randotin_jump, // use randotin_jump
  react,
  recognition,
  rotator,
  saccades,
  line_reading: comprehension, // use comprehension
  comprehension_v2: comprehension, // use comprehension
  stereoacuity,
  tachistoscope,
  visual_auditory,
  visual_memory,
  vectograph,
  wordreading,
  jumble_scan,
  example_click_the_target,
  example_speech_to_text,
  dictation,
  calibration_check,
  okn_drum,
  memory_match,
  vergence,
  vergence_in: vergence,
  vergence_out: vergence,
  vergence_vertical,
  vergence_jump_in: vergence_jump_base,
  vergence_jump_out: vergence_jump_base,
  vergence_jump_inout: vergence_jump_inout,
  vergence_jump_vertical: vergence_jump_vertical,
  worth_four_dot,
  central_suppression_check,
  saccadic_rapid_naming,
};
